/**
 * Web stub — see `IncallSelfView.web.tsx` for the rationale. We just paint
 * the Blue Whale backdrop so the screen still has the right chrome on web
 * even though the actual call surface lives in `meet.html`.
 */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, {
  Defs,
  Path,
  Filter,
  FeGaussianBlur,
  G,
} from 'react-native-svg';

const BLUE_WHALE = '#002E49';

export default function IncallRemoteBackground() {
  return (
    <View style={[styles.fill, { backgroundColor: BLUE_WHALE }]}>
      <Svg
        style={StyleSheet.absoluteFill}
        width="100%"
        height="100%"
        viewBox="0 0 393 852"
        preserveAspectRatio="xMidYMid slice"
        pointerEvents="none"
      >
        <Defs>
          <Filter id="blurA" x="-47.0823" y="-470.264" width="908.391" height="939.231">
            <FeGaussianBlur stdDeviation="72.3908" />
          </Filter>
          <Filter id="blurB" x="-384.246" y="83.3556" width="838.692" height="868.497">
            <FeGaussianBlur stdDeviation="72.3908" />
          </Filter>
          <Filter id="blurC" x="-80.3063" y="542.699" width="696.597" height="566.597">
            <FeGaussianBlur stdDeviation="61.1492" />
          </Filter>
        </Defs>
        <G opacity={0.6}>
          <Path
            d="M165.377 -262.213C275.386 -372.221 314.045 -332.911 457.286 -189.67C600.526 -46.4292 794.106 146.499 684.098 256.507C574.089 366.516 368.791 339.575 225.55 196.335C82.3094 53.094 55.3692 -152.205 165.377 -262.213Z"
            fill="#FFFFFF"
            filter="url(#blurA)"
          />
        </G>
        <G>
          <Path
            d="M-134.056 769.588C-278.437 689.61 -256.242 650.552 -176.264 506.171C-96.2867 361.791 11.188 166.762 155.568 246.74C299.949 326.718 352.158 508.596 272.18 652.976C192.202 797.356 10.3242 849.565 -134.056 769.588Z"
            fill="#015480"
            filter="url(#blurB)"
          />
        </G>
        <G opacity={0.5}>
          <Path
            d="M267.992 983.061C143.176 983.061 41.9922 1016.03 41.9922 891.137C41.9922 766.243 143.176 664.997 267.992 664.997C392.809 664.997 493.992 766.243 493.992 891.137C493.992 1016.03 392.809 983.061 267.992 983.061Z"
            fill="#151515"
            filter="url(#blurC)"
          />
        </G>
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  fill: { ...StyleSheet.absoluteFillObject, overflow: 'hidden' },
});
